import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bitly = defineConnector({
  identifier: "bitly",
  name: "Bitly",
  tagLine: "URL shortening and analytics",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api-ssl\\.bitly\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Bitly API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Bitly Developer Settings](https://app.bitly.com/settings/api/) and generate an **Access Token**.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Access Token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api-ssl.bitly.com/v4/user",
  },
});
